enum States {
  active = 'active',
  pending = 'pending',
  deleted = 'deleted',
  suspended = 'suspended',
}

export { States }
export default States
